import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { UsersApi } from '@shared/api/rest';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';
import type { GenerateCodeRequest, GenerateCodeResponse } from '@shared/api/rest/users';

const effect = createEffect((params: IQueryParams<GenerateCodeRequest>) => UsersApi.generateCode(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<GenerateCodeResponse | null>(null)
  .on(effect.done, (_, values) => values.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $generateOTPCodeStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
